import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../api";

export default{
    getDataItem: async ({ commit }, payload) => {
        try {
            const res = await conn.get(api.listItem, payload)
            if (res.data.code === 200) {
                if (res.data.data) {
                    if (payload.offset > 0) {
                        commit("updateListItem", res.data.data);
                }
                else {
                        commit("setListDataItem", res.data.data);
                    }
                }
            }
        } catch (e) {
            console.log(e);
            this.$toast.error(e)
        }
    },
}